// APIs
export const DOMAIN = process.env.REACT_APP_API_DOMAIN;
// export const DOMAIN = 'https://test.cleandesk.co.in';

export const CHAT_DOMAIN = process.env.REACT_APP_SOCKET_DOMAIN;

export const AI_DOMAIN = process.env.REACT_APP_AI_DOMAIN;

export const DEMO_DOMAIN = process.env.REACT_APP_DEMO_DOMAIN;

export const KB_DOMAIN = process.env.REACT_APP_KB_API_DOMAIN;

export const CDN_DOMAIN = process.env.REACT_APP_CDN_DOMAIN;

// Versioned APIs
export const BASIC_URL = `${DOMAIN}/api/v1`;
export const BASIC_URL_V2 = `${DOMAIN}/api/v2`;
export const BASIC_URL_V3 = `${DOMAIN}/api/v3`;

export const BASIC_AI_URL = `${AI_DOMAIN}/api/v1`;

export const BASIC_AI_URL_V1 = `${AI_DOMAIN}/api/v1`;

export const BASIC_KB_URL = `${KB_DOMAIN}/api/v1`;

export const CHAT_MODULE_URL = `${CHAT_DOMAIN}/api/v1`;
// export const CHAT_MODULE =
//   process.env.REACT_APP_ENV === 'test'
//     ? 'https://testsupport.cleandesk.co.in'
//     : process.env.REACT_APP_SUPPORT_PATH;

export const MAIL_DOMAIN =
  process.env.REACT_APP_MAIL_DOMAIN || 'https://test.mail.oho.works/api/v1';

export const SUPPORT_MODULE_SOCKET = process.env.REACT_APP_SUPPORT_SOCKET;

// v1
export const POST_MANAGEMENT_MODULE = `${BASIC_URL}/post`;
export const REGISTRATION_MODULE = `${BASIC_URL}/rl`;
export const PROFILE_MANAGEMENT_MODULE = `${BASIC_URL}/user`;
export const LEGISLATOR_MANAGEMENT_MODULE = `${BASIC_URL}/organisation`;
export const NETWORK_MODULE = `${BASIC_URL}/network`;
export const RATING_REVIEW_MODULE = `${BASIC_URL}/rr`;
export const STANDARD_DICTIONARIES_MODULE = `${BASIC_URL}/standard`;
export const UTILITY_MODULE = `${BASIC_URL}/utility`;
export const BI_MODULE = `${BASIC_URL}/bi`;
export const HELPDESK_MODULE = `${BASIC_URL}/hd`;
export const CONTENT_MODULE = `${BASIC_URL}/content`;
export const AAA_MODULE = `${BASIC_URL}/aaa`;
export const AI_MODULE = `${BASIC_URL}/ai`;
export const NOTIFICATION_MODULE = `${BASIC_URL}/notification`;

export const NEW_SUBSCTIPTION_MODULE = `${BASIC_URL}/sm`;

export const TEAM_MODULE = `${LEGISLATOR_MANAGEMENT_MODULE}/team`;
export const CAMPAIGN_MODULE = `${BASIC_URL}/campaign`;
export const BRANCHES_MODULE = `${LEGISLATOR_MANAGEMENT_MODULE}/branch`;

export const CHAT_MODULE = `${CHAT_DOMAIN}/messenger`;

export const KB_DOCUMENT_MODULE = `${BASIC_KB_URL}/document`;

export const GATEWAY_MODULE = `${AAA_MODULE}/gateway`;

export const SUBSCRIPTION_MODULE = `${AAA_MODULE}/subscription`;

export const AGENT_MODULE = `${BASIC_AI_URL}/ai/agent`;

export const GEO_MODULE = `${BASIC_URL}/geo`;
export const GEO_LOCATION_MODULE = `${GEO_MODULE}/location`;

export const CRM_MODULE = `${BASIC_URL}/crm`;

export const PARTNER_MODULE = `${BASIC_URL}/partner`;
export const PARTNER_HIERARCHY_MODULE = `${PARTNER_MODULE}/hierarchy`;

export const ATS_MODULE = `${BASIC_URL}/ats`;

export const ROLE_PERMISSION_MODULE = `${BASIC_URL}/rp`;

export const AUDIENCE_MODULE = `${BASIC_URL}/audience`;
export const AUDIENCE_ROOM_MODULE = `${AUDIENCE_MODULE}/room`;

export const LOYALTY_MODULE = `${BASIC_URL}/loyalty`;
export const LOYALTY_TRANSACTION_MODULE = `${LOYALTY_MODULE}/transaction`;

export const BUSINESS_UNIT_MODULE = `${BASIC_URL}/bussinessunit`;

export const REDEMPTION_MODULE = `${BASIC_URL}/redemption`;

export const TARGET_MODULE = `${BASIC_URL}/target`;

// v2
export const LEGISLATOR_MANAGEMENT_MODULE_V2 = `${BASIC_URL_V2}/organisation`;
export const UTILITY_MODULE_V2 = `${BASIC_URL_V2}/utility`;
export const HELPDESK_MODULE_V2 = `${BASIC_URL_V2}/hd`;

// v3
export const UTILITY_MODULE_V3 = `${BASIC_URL_V3}/utility`;

// common apis
export const INVITATIONS_LISTING = BASIC_URL + '/invitation/list';
